import { GenericDialog } from '@AMIEWEB/Alerts/GenericDialog';
import { CancelButton } from '@AMIEWEB/Common/Buttons/CancelButton';
import { gridSelectionActions } from '@AMIEWEB/Common/Grid/GridSelection/GridSelection.redux';
import {
  TemplateUserTypes,
  deriveAttentionToOpts,
  deriveSendToOpts,
} from '@AMIEWEB/Common/SubmissionPreference/Common/helper';
import { validationSchema } from '@AMIEWEB/Common/SubmissionPreference/Common/validation';
import { initialSendPacketState } from '@AMIEWEB/Common/SubmissionPreference/SubmissionLimit/SendPacketAutomation';
import {
  FacilityContactSliceKey,
  FacilityContactsReducer,
} from '@AMIEWEB/Facility/FacilityDetails/FacilityTabs/ContactTab/Store/FacilityContacts.redux';
import { facilityClientContactsSaga } from '@AMIEWEB/Facility/FacilityDetails/FacilityTabs/ContactTab/Store/FacilityContacts.saga';
import {
  FacilityUnitActions,
  FacilityUnitKey,
  FacilityUnitReducer,
} from '@AMIEWEB/Facility/FacilityDetails/FacilityTabs/UnitTab/Store/FacilityUnit.redux';
import { facilityUnitsSaga } from '@AMIEWEB/Facility/FacilityDetails/FacilityTabs/UnitTab/Store/FacilityUnit.saga';
import { selectFacility } from '@AMIEWEB/Facility/FacilityStore/Facility.selector';
import { ButtonSection } from '@AMIEWEB/Order/OrderDesign';
import { orderDataActions, orderDataReducer, orderDataSliceKey } from '@AMIEWEB/Order/Store/Order.redux';
import { orderDataSaga } from '@AMIEWEB/Order/Store/Order.saga';
import { orderCreationActions } from '@AMIEWEB/Order/Store/OrderCreation.actions';
import { orderCreationReducer, orderCreationSliceKey } from '@AMIEWEB/Order/Store/OrderCreation.redux';
import { orderCreationSaga } from '@AMIEWEB/Order/Store/OrderCreation.saga';
import {
  ISubmissionEmail,
  ISubmissionPacket,
  getFormattedSubmissionEmail,
  getFormattedSubmissionPacket,
} from '@AMIEWEB/Unit/UnitDetails/UnitTabs/Preferences/helper/unitHelper';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid, Typography } from '@mui/material';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { AMNDivisionType } from 'app/models/enums/AMNDivisionType';
import { selectUser } from 'oidc/user.selectors';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation, useParams, useNavigationType } from 'react-router-dom';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { createOrderOcbrSaga } from 'store/redux-store/create-order-ocbr/saga';
import { createOrderOcbrReducer, createOrderOcbrSliceKey } from 'store/redux-store/create-order-ocbr/slice';
import { initialSubmissionPreferences } from 'store/redux-store/create-order-preferences/initialState';
import { orderCreationNewPreferenceSaga } from 'store/redux-store/create-order-preferences/saga';
import {
  selectCreateOrderPreference,
  selectFormDirty,
  selectIsUnitPreferenceNull,
  selectMiscellaneousData,
  selectTabValue,
  selectUnitDialoge,
  selectUnitInherited,
} from 'store/redux-store/create-order-preferences/selectors';
import {
  createOrderPreferenceActions,
  createOrderPreferenceReducer,
  createOrderPreferenceSliceKey,
} from 'store/redux-store/create-order-preferences/slice';
import {
  notificationDataActions,
  notificationDataKey,
  notificationDataReducer,
} from 'store/redux-store/notification/notification.redux';
import { notificationSaga } from 'store/redux-store/notification/notification.saga';
import { selectPacketCategoryTitles } from 'store/redux-store/notification/notification.selector';
import { makeStyles } from 'tss-react/mui';
import { isValidJSONString } from 'utils/string/string';
import {
  selectActiveStep,
  selectAdditionalRequiredText,
  selectClientContacts,
  selectDisableNextBtnSidePanel,
  selectEditOrderId,
  selectNewOrderCreatedFromUnit,
  selectPage2,
  selectPage3,
  selectPreferences,
  selectPreferredQualificationText,
  selectInternalNotes,
  selectJobDescription,
  selectPreviewTabSelected,
  selectUnitId,
  selectedOrderTypeDetails,
  selectOrderLicenseOptions,
  selectOrderLicenseComapctStatusOptions,
} from '../../Store/Order.selectors';
import { orderCreationNewActions } from '../../Store/OrderCreation.actions';
import { orderCreationNewReducer, orderCreationNewSliceKey } from '../../Store/OrderCreation.redux';
import { IOrderCreationParams, OrderCreationStepEnum, OrderCreationSteps, initialPacketState } from '../../types';
import { AdditionalRequirements } from '../AdditionalRequirements/AdditionalRequirements';
import OrderDetails from '../OrderDetails/OrderDetails';
import OrderRequirements from '../OrderRequirements/OrderRequirements';
import { PreviewAndSubmit } from '../PreviewAndSubmit/PreviewAndSubmit';
import { UnitSelection } from '../UnitSelection/UnitSelection';
import { getOperation, getPrimarySkillSets, getSkillSetsLength, transformSkillSetGroupData } from '../helper';
import InheritUnitPreferenceDialog from './InheritUnitPreference';
import { OrderNavigationMenu } from './OrderNavigationMenu';
import useDocumentTitle from 'utils/customHooks/useDocumentTitle';
import { TemplateCategory } from '@AMIEWEB/Common/SubmissionPreference/SubmissionEmail/AddTemplateModal';
import { useDecision } from '@optimizely/react-sdk';
import { isEmpty, cloneDeep } from 'lodash';
import { CollectionType } from 'app/enums/Common';
import { RequirementType } from 'app/enums/Facility';
import { IOrderFreeText } from 'app/models/Orders/OrderDetails';
import { selectOrderDetailsOrderType } from '@AMIEWEB/Order/Store/Order.selectors';
import { ff_order_ui_allow_duplicate_skillsets } from 'app/constants/FeatureFlags/Order/Keys';

const useStyles = makeStyles<{ isPreviewTabSelected: boolean; activeStep: OrderCreationStepEnum }>()(
  (theme, { isPreviewTabSelected, activeStep }) => ({
    bodyContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
    },
    tabContainer: {
      width: isPreviewTabSelected ? '100%' : '87%',
      paddingLeft: activeStep !== OrderCreationStepEnum.PreviewAndSubmit ? '12px' : '0px',
    },
    btnContainer: {
      display: 'flex',
      minWidth: '12.5%',
      justifyContent: 'space-between',
      gap: '24px',
      paddingRight: '7px',
    },
    btnStyle: {
      padding: '10px 24px',
      cursor: 'pointer',
    },
  }),
);
export enum ForwardBack {
  Next,
  Back,
}

export const NewOrderBody = ({ breadCrumbOptions }: { breadCrumbOptions: IOrderCreationParams[] }) => {
  useInjectReducer({ key: orderCreationNewSliceKey, reducer: orderCreationNewReducer });
  useInjectReducer({ key: createOrderPreferenceSliceKey, reducer: createOrderPreferenceReducer });
  useInjectSaga({ key: createOrderPreferenceSliceKey, saga: orderCreationNewPreferenceSaga });

  useInjectReducer({ key: orderDataSliceKey, reducer: orderDataReducer });
  useInjectSaga({ key: orderDataSliceKey, saga: orderDataSaga });
  useInjectReducer({ key: orderCreationSliceKey, reducer: orderCreationReducer });
  useInjectSaga({ key: orderCreationSliceKey, saga: orderCreationSaga });

  useInjectReducer({ key: orderCreationSliceKey, reducer: orderCreationReducer });
  useInjectSaga({ key: orderCreationSliceKey, saga: orderCreationSaga });
  useInjectReducer({ key: createOrderOcbrSliceKey, reducer: createOrderOcbrReducer });
  useInjectSaga({ key: createOrderOcbrSliceKey, saga: createOrderOcbrSaga });
  useInjectSaga({ key: FacilityUnitKey, saga: facilityUnitsSaga });
  useInjectSaga({ key: FacilityContactSliceKey, saga: facilityClientContactsSaga });
  useInjectReducer({ key: FacilityContactSliceKey, reducer: FacilityContactsReducer });
  useInjectReducer({ key: FacilityUnitKey, reducer: FacilityUnitReducer });

  useInjectSaga({ key: FacilityUnitKey, saga: facilityUnitsSaga });
  useInjectReducer({ key: FacilityUnitKey, reducer: FacilityUnitReducer });

  useInjectReducer({ key: createOrderOcbrSliceKey, reducer: createOrderOcbrReducer });
  useInjectSaga({ key: createOrderOcbrSliceKey, saga: createOrderOcbrSaga });
  useInjectReducer({ key: notificationDataKey, reducer: notificationDataReducer });
  useInjectSaga({ key: notificationDataKey, saga: notificationSaga });

  const { t } = useTranslation();
  const activeStep = useSelector(selectActiveStep);
  const orderId = useSelector(selectEditOrderId);
  const { pathname } = useLocation();
  const isEdit = !!orderId || pathname.includes('/edit');
  const page2 = useSelector(selectPage2);
  const page3 = useSelector(selectPage3);
  const orderPreferences = useSelector(selectPreferences);
  const page1 = useSelector(selectedOrderTypeDetails);
  const selectedUnitId = useSelector(selectUnitId);
  const isPreviewTabSelected = useSelector(selectPreviewTabSelected);
  const isUnitPreferenceNull = useSelector(selectIsUnitPreferenceNull);
  const unitDialoge = useSelector(selectUnitDialoge);
  const tabValue = useSelector(selectTabValue);
  const unitInherited = useSelector(selectUnitInherited);
  const facilityValue = useSelector(selectFacility);
  const selectedOrderAdditionalRequirement = useSelector(selectAdditionalRequiredText);
  const selectedOrderPreferredQualificationText = useSelector(selectPreferredQualificationText);
  const selectedOrderInternalNotes = useSelector(selectInternalNotes);
  const selectedOrderJobDescription = useSelector(selectJobDescription);
  const [enableDuplicateSkillSet] = useDecision(ff_order_ui_allow_duplicate_skillsets);

  const {
    rfoToSent,
    wfcToRfo,
    candidateTasks,
    sendPacket: apiSendPacket,
    savePacket,
    submissionEmailSetup,
    submissionPacketSetup,
  } = useSelector(selectCreateOrderPreference);

  const { userInfo } = useSelector(selectUser);
  const clientContacts = useSelector(selectClientContacts);
  const categoryTitles = useSelector(selectPacketCategoryTitles);
  const { disableEmailContainer } = useSelector(selectMiscellaneousData);
  const FormDirty = useSelector(selectFormDirty);
  const disableBtnsidePanel = useSelector(selectDisableNextBtnSidePanel);
  const isNewOrderCreatedFromUnit = useSelector(selectNewOrderCreatedFromUnit);
  const orderLicenseOptions = useSelector(selectOrderLicenseOptions);
  const compactStatusOptions = useSelector(selectOrderLicenseComapctStatusOptions);

  const dispatch = useDispatch();
  const history = useNavigate();
  const locations = useRef('');
  const navigationType = useNavigationType();
  const [cancelModal, setCancelModal] = useState<boolean>(false);
  const [isSubmitDisabledForEdit, setSubmitDisabledForEdit] = useState(true);
  const [removeSkillSetModal, setRemoveSkillSetModal] = useState<boolean>(false);
  const [isCancelButtonClick, SetCancelButtonClick] = useState<boolean>(false);
  const { id: facilityId } = useParams<{ id: string }>();
  const { promiseInProgress: isUpdating } = usePromiseTracker({ area: 'update-order', delay: 0 });
  const { promiseInProgress: isSubmitting } = usePromiseTracker({ area: 'submit-order', delay: 0 });
  const { classes } = useStyles({ isPreviewTabSelected, activeStep });
  const isPrefrence = unitDialoge?.dialogeItem === 'preference';
  const isorderPreview = unitDialoge?.dialogeItem === 'orderPreview';
  useDocumentTitle(
    isEdit ? { title: `Edit Order - OID ${facilityId}` } : { title: `Create Order - FID ${facilityId}` },
  );
  const selectOrderDetailOrderType = useSelector(selectOrderDetailsOrderType);

  const mapStoreToStep = {
    [OrderCreationStepEnum.OrderRequirements]: page1,
    [OrderCreationStepEnum.AdditionalRequirements]: page2,
    [OrderCreationStepEnum.OrderDetails]: {
      ...page3,
      additionalRequiredQualifications: selectedOrderAdditionalRequirement,
      preferredQualifications: selectedOrderPreferredQualificationText,
      internalNotes: selectedOrderInternalNotes,
      jobDescription: selectedOrderJobDescription,
    },
    [OrderCreationStepEnum.PreviewAndSubmit]: orderPreferences,
  };
  const getDefaultValues = (step?: OrderCreationStepEnum) => {
    return mapStoreToStep[step ?? activeStep];
  };

  const formMethods = useForm({
    defaultValues: cloneDeep(getDefaultValues()),
    resolver: !disableEmailContainer ? yupResolver(validationSchema) : null,
    mode: 'onChange',
    reValidateMode: 'onSubmit',
  });

  const {
    handleSubmit,
    trigger,
    watch,
    reset,
    setError,
    formState: { isDirty, dirtyFields },
  } = formMethods;
  const currentFormData = watch();
  const additionalRequirementsRef = useRef<HTMLDivElement | null>(null);
  // const skillsRef = useRef<HTMLDivElement | null>(null);
  const clinicianToPatientRef = useRef<HTMLDivElement | null>(null);
  const virtualInterviewRef = useRef<HTMLDivElement | null>(null);
  const orderPriorityRef = useRef<HTMLDivElement | null>(null);
  const bestBetsRef = useRef<HTMLDivElement | null>(null);
  const referencesRef = useRef<HTMLDivElement | null>(null);
  const workHistoryRef = useRef<HTMLDivElement | null>(null);
  // const clinicianResourceRef = useRef<HTMLDivElement | null>(null);
  const strikeDetailsRef = useRef<HTMLDivElement | null>(null);
  const orderRequirementsRef = useRef<HTMLDivElement | null>(null);
  const orderTypeRef = useRef<HTMLDivElement | null>(null);
  // const rateCardRef = useRef<HTMLDivElement | null>(null);
  // const effectiveDateRef = useRef<HTMLDivElement | null>(null);
  // const offContractRateElementsRef = useRef<HTMLDivElement | null>(null);
  const previewAndSubmitRef = useRef<HTMLDivElement | null>(null);
  const orderDetailsRef = useRef<HTMLDivElement | null>(null);
  const scheduleRef = useRef<HTMLDivElement | null>(null);
  const placementTermsRef = useRef<HTMLDivElement | null>(null);
  const technologyInformationRef = useRef<HTMLDivElement | null>(null);
  const additionalRequiredQualificationsRef = useRef<HTMLDivElement | null>(null);
  const preferredQualificationsRef = useRef<HTMLDivElement | null>(null);
  const internalNotesRef = useRef<HTMLDivElement | null>(null);
  const externalJobDescriptionRef = useRef<HTMLDivElement | null>(null);

  const navRefs = React.useMemo(() => {
    return [
      {
        label: `${t('placement.profile.tabs.orderRequirements')}`,
        navRef: orderRequirementsRef,
        mainMenuItem: true,
        categoryIndex: 1,
        id: 1,
      },
      {
        label: `${t('order.newOrderCreation.tabs.orderTypeDetails')}`,
        navRef: orderTypeRef,
        categoryIndex: 1,
        id: 2,
      },
      {
        label: `${t('order.newOrderCreation.tabs.experience')}`,
        navRef: orderTypeRef,
        categoryIndex: 1,
        id: 3,
      },
      {
        label: `${t('placement.profile.tabs.additionalRequirements')}`,
        navRef: additionalRequirementsRef,
        mainMenuItem: true,
        categoryIndex: 2,
        id: 4,
      },
      //commented for future use
      // {
      //   label: `${t('order.newOrderCreation.tabs.skillAndProcedure')}`,
      //   navRef: skillsRef,
      //   categoryIndex: 2,
      // },
      {
        label: `${t('order.newOrderCreation.tabs.clinicianToPatientRatio')}`,
        navRef: clinicianToPatientRef,
        categoryIndex: 2,
        id: 5,
      },
      {
        label: `${t('order.newOrderCreation.tabs.virtualInterviewRating')}`,
        navRef: virtualInterviewRef,
        categoryIndex: 2,
        id: 6,
      },
      {
        label: `${t('order.newOrderCreation.tabs.orderPriorities')}`,
        navRef: orderPriorityRef,
        categoryIndex: 2,
        id: 7,
      },
      {
        label: `${t('order.newOrderCreation.tabs.bestBets')}`,
        navRef: bestBetsRef,
        categoryIndex: 2,
        id: 8,
      },
      {
        label: `${t('order.newOrderCreation.tabs.references')}`,
        navRef: referencesRef,
        categoryIndex: 2,
        id: 9,
      },
      {
        label: `${t('order.newOrderCreation.tabs.workHistory')}`,
        navRef: workHistoryRef,
        categoryIndex: 2,
        id: 10,
      },
      {
        label: `${t('order.newOrderCreation.tabs.strikrDetails')}`,
        navRef: strikeDetailsRef,
        categoryIndex: 2,
        id: 11,
      },
      {
        label: `${t('order.newOrderCreation.tabs.orderDetails')}`,
        navRef: orderDetailsRef,
        mainMenuItem: true,
        categoryIndex: 3,
        id: 12,
      },
      {
        label: `${t('order.newOrderCreation.tabs.schedule')}`,
        navRef: scheduleRef,
        categoryIndex: 3,
        id: 13,
      },
      {
        label: `${t('order.newOrderCreation.tabs.placementTerms')}`,
        navRef: placementTermsRef,
        categoryIndex: 3,
        id: 14,
      },
      {
        label: `${t('order.newOrderCreation.tabs.technologyInformation')}`,
        navRef: technologyInformationRef,
        categoryIndex: 3,
        id: 15,
      },
      {
        label: `${t('order.newOrderCreation.tabs.additionRequirements')}`,
        navRef: additionalRequiredQualificationsRef,
        categoryIndex: 3,
        multiLine: true,
        id: 16,
      },
      {
        label: `${t('order.newOrderCreation.tabs.preferredQualification')}`,
        navRef: preferredQualificationsRef,
        categoryIndex: 3,
        id: 17,
      },
      {
        label: `${t('order.newOrderCreation.tabs.internalNotes')}`,
        navRef: internalNotesRef,
        categoryIndex: 3,
        id: 18,
      },
      {
        label: `${t('order.newOrderCreation.tabs.externalJobDescription')}`,
        navRef: externalJobDescriptionRef,
        categoryIndex: 3,
        id: 19,
      },
      //
      //commented for future use
      // {
      //   label: `${t('order.newOrderCreation.tabs.rateCard')}`,
      //   navRef: rateCardRef,
      //   mainMenuItem: true,
      //   categoryIndex: 4,
      // },
      // {
      //   label: `${t('order.newOrderCreation.tabs.effectiveDate')}`,
      //   navRef: effectiveDateRef,
      //   categoryIndex: 4,
      // },
      // {
      //   label: `${t('order.newOrderCreation.tabs.offContractRateElements')}`,
      //   navRef: offContractRateElementsRef,
      //   categoryIndex: 4,
      // },
      !isEdit && {
        label: `${t('order.newOrderCreation.tabs.previewAndSubmit')}`,
        navRef: previewAndSubmitRef,
        mainMenuItem: true,
        categoryIndex: 4,
        id: 20,
      },
    ];
  }, []);

  const updateOrderFreeTextDetails = (data, needUpdate) => {
    const orderFreeTextDetails: IOrderFreeText = {
      additionalRequiredQualifications: data?.additionalRequiredQualifications ?? '',
      internalNotes: data?.internalNotes ?? '',
      jobDescription: data?.jobDescription ?? '',
      preferredQualifications: data?.preferredQualifications ?? '',
      requiredQualifications: data?.requiredQualifications ?? '',
    };
    if (needUpdate) dispatch(orderCreationNewActions.setOrderQualificationFreeText(orderFreeTextDetails));
  };

  const handleBack = async () => {
    if (!isEdit) {
      let index = OrderCreationSteps.findIndex(a => a === activeStep);
      const isValid = await trigger();
      if (index <= OrderCreationStepEnum.OrderRequirements || (index < OrderCreationSteps.length && isValid)) {
        getDispatchFunctionStepWise(ForwardBack.Back);
        dispatch(orderCreationNewActions.setActiveStep(OrderCreationSteps[index - 1]));
        if (activeStep === OrderCreationStepEnum.OrderRequirements) {
          dispatch(orderCreationNewActions.resetForm());
          dispatch(gridSelectionActions.setGridSelections({ selectedData: [] }));
        }
      }
    }
  };

  const getDispatchFunctionStepWise = (calledFrom = ForwardBack.Next) => {
    if (compactStatusOptions?.length === 0) {
      dispatch(orderCreationNewActions.getOrderLicenseCompactStatusOptions());
    }
    switch (activeStep) {
      case OrderCreationStepEnum.UnitSelection:
        if (calledFrom === ForwardBack.Back) {
          dispatch(orderCreationNewActions.reset());
        } else {
          dispatch(orderCreationNewActions.getSkillsetForSelectedUnitAction({ unitId: selectedUnitId }));
        }
        break;
      case OrderCreationStepEnum.OrderRequirements:
        const isAnd = getOperation(currentFormData);
        if (
          facilityValue?.facilityResponse?.amnDivisionTypeId === AMNDivisionType.amnNurse &&
          (!enableDuplicateSkillSet.enabled || isAnd) &&
          getSkillSetsLength(currentFormData)
        ) {
          setRemoveSkillSetModal(true);
        } else {
          setRemoveSkillSetModal(false);
          const updatedFormData = {
            ...currentFormData,
            skillSetGroup: {
              ...currentFormData.skillSetGroup,
              ...transformSkillSetGroupData(currentFormData?.skillSetGroup),
            },
          };
          dispatch(orderCreationNewActions.setPage1FormData(cloneDeep(updatedFormData)));
        }
        // dispatch(orderCreationNewActions.setSkillSetGroupTransFormed(currentFormData?.skillSetGroup));
        break;
      case OrderCreationStepEnum.AdditionalRequirements:
        dispatch(orderCreationNewActions.setPage2FormData(cloneDeep(currentFormData)));
        break;
      case OrderCreationStepEnum.OrderDetails:
        updateOrderFreeTextDetails(currentFormData, !isEdit);
        dispatch(orderCreationNewActions.setPage3FormData(cloneDeep(currentFormData)));
        break;
      case OrderCreationStepEnum.PreviewAndSubmit:
        dispatch(
          orderCreationNewActions.setPreferencesFormData(
            cloneDeep({
              ...currentFormData,
              updatedBy: userInfo.employeeId,
              orderId: !isEdit ? 0 : parseInt(orderId),
            }),
          ),
        );
        break;
    }
  };

  const getErrorInfo = currentFormData => {
    const errorArray = currentFormData?.skillSetGroup?.groups?.flatMap(group =>
      group?.skillsets?.flatMap(skillset =>
        skillset?.collections[0]?.requirements?.map(requirement => requirement?.isError),
      ),
    );
    return errorArray?.some(obj => obj?.compactStatus || obj?.state);
  };

  const handleNext = async () => {
    if (activeStep === OrderCreationStepEnum.UnitSelection) {
      const faciltyDetail =
        facilityValue?.facilityResponse?.location?.state ?? facilityValue?.response?.location?.state;
      if (faciltyDetail && orderLicenseOptions?.length === 0)
        dispatch(orderCreationNewActions.getOrderLicenseOptions(faciltyDetail));
      dispatch(createOrderPreferenceActions.getUnitPreferences({ unitId: selectedUnitId }));
    }
    if (activeStep === OrderCreationStepEnum.OrderRequirements) {
      let hasSubCertificateError = false;
      currentFormData?.skillSetGroup?.groups?.forEach((group, groupIdx) => {
        group?.skillsets?.forEach((skillSet, skillSetIdx) => {
          const requirements =
            skillSet?.collections?.[CollectionType.CertificationsIndex]?.requirements || [];
          requirements?.forEach((requirement, requirementIdx) => {
            if (
              requirement?.certificates?.object?.requirementTypeID === RequirementType.cert &&
              (!requirement?.subCertificate ||
                (Array.isArray(requirement?.subCertificate) && requirement?.subCertificate.length === 0))
            ) {
              setError(
                `skillSetGroup.groups[${groupIdx}].skillsets[${skillSetIdx}].collections[${CollectionType.CertificationsIndex}].requirements[${requirementIdx}].subCertificate`,
                {
                  type: 'required',
                  message: t('required'),
                },
              );
              hasSubCertificateError = true;
            }
          });
        });
      });
      if (hasSubCertificateError) {
        return;
      }
    }
    const isValid = await trigger();
    if (isEdit && isValid && !getErrorInfo(currentFormData)) {
      //dispatch edit order;
      getDispatchFunctionStepWise();
      if (activeStep === OrderCreationStepEnum.OrderDetails) {
        updateOrderFreeTextDetails(currentFormData, isEdit);
      }
      dispatch(orderCreationNewActions.onEditOrder());
    } else {
      let index = OrderCreationSteps?.findIndex(a => a === activeStep);
      if (index < OrderCreationSteps?.length - 1 && isValid && !getErrorInfo(currentFormData)) {
        getDispatchFunctionStepWise();
        const isAnd = getOperation(currentFormData);
        if (
          facilityValue?.facilityResponse?.amnDivisionTypeId === AMNDivisionType.amnNurse &&
          (!enableDuplicateSkillSet.enabled || isAnd) &&
          activeStep === OrderCreationStepEnum.OrderRequirements &&
          getSkillSetsLength(currentFormData)
        ) {
          dispatch(orderCreationNewActions.setActiveStep(OrderCreationSteps[index]));
        } else {
          dispatch(orderCreationNewActions.setActiveStep(OrderCreationSteps[index + 1]));
        }
      } else if (activeStep === OrderCreationStepEnum.PreviewAndSubmit) {
        const unitDialoge = {
          dialogeOpen: true,
          dialogeItem: 'orderPreview',
        };
        const formValue = { ...currentFormData, updatedBy: userInfo.employeeId, orderId: !isEdit ? 0 : orderId };
        dispatch(orderCreationNewActions.setPreferencesFormData(cloneDeep(formValue)));
        !unitInherited && !isUnitPreferenceNull
          ? dispatch(createOrderPreferenceActions.setUnitDialoge(unitDialoge))
          : dispatch(orderCreationNewActions.onSubmitOrder(history));
      }
    }
  };

  const routeToLandingPage = () => {
    dispatch(orderDataActions.setSelectedSubCert([]));
    if (isEdit) {
      history(`/order/${orderId}`);
    } else if (isNewOrderCreatedFromUnit) {
      history(`/facility/${facilityId}/unit/${selectedUnitId}`);
    } else {
      history(`/facility/${facilityId}`);
    }
  };

  const handleCancel = () => {
    SetCancelButtonClick(true);

    if (isEmpty(dirtyFields)) {
      routeToLandingPage();
    } else {
      setCancelModal(true);
    }
  };

  const checkDisableForNext = () => {
    switch (activeStep) {
      case OrderCreationStepEnum.OrderRequirements:
        return disableBtnsidePanel;
      case OrderCreationStepEnum.PreviewAndSubmit:
        return true;
      case OrderCreationStepEnum.UnitSelection:
        return !selectedUnitId;
      default:
        return false;
    }
  };

  const handleMenuItemClick = async index => {
    const isValid = await trigger();
    if (isValid && !getErrorInfo(currentFormData)) {
      if (index !== activeStep) {
        getDispatchFunctionStepWise();
        reset(cloneDeep(mapStoreToStep[index]));
      }
      if (activeStep === OrderCreationStepEnum.OrderDetails && isEdit) {
        updateOrderFreeTextDetails(currentFormData, true);
      }
      const isAnd = getOperation(currentFormData);
      if (
        facilityValue?.facilityResponse?.amnDivisionTypeId === AMNDivisionType.amnNurse &&
        (!enableDuplicateSkillSet.enabled || isAnd) &&
        activeStep === OrderCreationStepEnum.OrderRequirements &&
        getSkillSetsLength(currentFormData)
      ) {
        dispatch(orderCreationNewActions.setActiveStep(OrderCreationStepEnum.OrderRequirements));
      } else {
        dispatch(orderCreationNewActions.setActiveStep(index));
      }
    }
  };

  const handleCancelDialogClose = () => {
    dispatch(orderDataActions.setDetailsCurrentStep('ViewOrderDetails'));
    setCancelModal(false);
    SetCancelButtonClick(false);
  };
  const handleDialogClose = () => {
    setRemoveSkillSetModal(false);
  };

  const handleCancelConfirm = () => {
    dispatch(createOrderPreferenceActions.setIsUnitInherited(false));
    dispatch(createOrderPreferenceActions.setIsFormDirty(false));
    if (isCancelButtonClick) {
      routeToLandingPage();
    } else {
      history(locations.current);
    }
    dispatch(orderDataActions.setSelectedSubCert([]));
    dispatch(orderDataActions.setDetailsCurrentStep('ViewOrderDetails'));
  };

  const handleRemoveSkillSet = () => {
    let index = OrderCreationSteps?.findIndex(a => a === activeStep);
    const updatedFormDatas = {
      ...currentFormData,
      skillSetGroup: {
        ...currentFormData.skillSetGroup,
        ...getPrimarySkillSets(currentFormData?.skillSetGroup),
      },
    };
    dispatch(orderCreationNewActions.setPage1FormData(cloneDeep(updatedFormDatas)));
    setRemoveSkillSetModal(false);
    dispatch(globalActions.closeBanner());
    dispatch(orderCreationNewActions.setActiveStep(OrderCreationSteps[index + 1]));
  };

  useEffect(() => {
    if (selectOrderDetailOrderType?.length === 0) {
      dispatch(orderDataActions.getOrderTypes());
    }
    dispatch(orderDataActions.getRegions());
    if (!isNewOrderCreatedFromUnit) dispatch(orderCreationNewActions.setTypeAheadOptions());
    dispatch(FacilityUnitActions.getIssuedBy());
    dispatch(orderCreationActions.requestOrderCreationRequirementTypesDetailsAction());
    dispatch(notificationDataActions.getTemplatesByCategory({ category: TemplateCategory.PacketSubmission }));
    dispatch(
      notificationDataActions.getFacilityTemplatesByCategory({
        category: TemplateCategory.PacketSubmission,
        userType: TemplateUserTypes.Facility,
        userId: parseInt(facilityId),
      }),
    );
    dispatch(notificationDataActions.getFacilityBaseTemplate({ userType: TemplateUserTypes.Facility }));
    dispatch(orderCreationNewActions.getOrderLicenseCompactStatusOptions());
    return () => {
      dispatch(orderCreationNewActions.setNewOrderCreatedFromUnit(false));
      SetCancelButtonClick(false);
    };
  }, []);

  useEffect(() => {
    // Recall saved values while creating a new order
    if (!isEdit && activeStep > OrderCreationStepEnum.UnitSelection && activeStep <= OrderCreationStepEnum.PreviewAndSubmit) {
        reset(cloneDeep(mapStoreToStep[activeStep]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep, page1, page2, page3, orderPreferences, reset]);

  useLayoutEffect(() => {
    // Reset the form with default values from the store and the additional default values
    if (isEdit && activeStep > OrderCreationStepEnum.UnitSelection && activeStep <= OrderCreationStepEnum.PreviewAndSubmit) {
        reset(cloneDeep(mapStoreToStep[activeStep]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep, page1, page2, page3, orderPreferences, reset]);

  useEffect(() => {
    // Set a timeout to change the parameter to false after 5 seconds
    const timer = setTimeout(() => {
      setSubmitDisabledForEdit(false);
    }, 7000);

    // Cleanup the timer when the component is unmounted
    return () => clearTimeout(timer);
  }, []);

  const resetPreferenceFormForm = React.useCallback(
    (int = false) => {
      const packetSetup: ISubmissionPacket = isValidJSONString(submissionPacketSetup)
        ? JSON.parse(submissionPacketSetup)
        : null;

      const emailSetup: ISubmissionEmail = isValidJSONString(submissionEmailSetup)
        ? JSON.parse(submissionEmailSetup)
        : null;

      const _sendPacket = rfoToSent
        ? {
            save: savePacket && !apiSendPacket,
            saveAndSend: apiSendPacket && savePacket,
            doNotSave: !savePacket,
          }
        : initialSendPacketState;
      const disablePacketContainer =
        !unitInherited && !int ? true : !((_sendPacket.saveAndSend || _sendPacket.save) && rfoToSent);
      dispatch(
        createOrderPreferenceActions.setMiscellaneousData({
          key: 'disablePacketContainer',
          value: disablePacketContainer,
        }),
      );

      const disableEmailContainer = !unitInherited && !int ? true : !(_sendPacket.saveAndSend && rfoToSent);
      dispatch(
        createOrderPreferenceActions.setMiscellaneousData({
          key: 'disableEmailContainer',
          value: disableEmailContainer,
        }),
      );

      const _attentionTo =
        !unitInherited && !int
          ? clientContacts
          : deriveAttentionToOpts(clientContacts, packetSetup?.attentionTo, disablePacketContainer);

      const _sendTo =
        !unitInherited && !int
          ? clientContacts
          : deriveSendToOpts(clientContacts, emailSetup?.sendTo, disableEmailContainer);

      if (activeStep === OrderCreationStepEnum.PreviewAndSubmit) {
        const defaultFormValue = {
          ...currentFormData,
          emailTemplate: categoryTitles?.[0]?.id ?? null,
          attentionTo: clientContacts,
          sendTo: clientContacts,
          packetTemplate: initialPacketState,
          sendPacket: initialSendPacketState,
          noteToFacility: '',
          updatedBy: userInfo?.employeeId,
          orderId: !isEdit ? 0 : orderId,
          wfcToRfo: false,
          candidateTasks: false,
          rfoToSent: false,
          savePacket: false,
          emailSettings: null,
        };
        const formValue = {
          ...currentFormData,
          wfcToRfo,
          candidateTasks,
          rfoToSent,
          sendPacket: _sendPacket,
          packetTemplate: disablePacketContainer ? initialPacketState : packetSetup?.packetTemplate,
          emailSettings: disableEmailContainer ? null : emailSetup?.bulkEmailSettings,
          emailTemplate: emailSetup?.emailTemplateId ?? categoryTitles?.[0]?.id ?? null,
          attentionTo: _attentionTo,
          sendTo: _sendTo,
          noteToFacility: disablePacketContainer ? '' : packetSetup?.noteToFacility,
          updatedBy: userInfo.employeeId,
          orderId: !isEdit ? 0 : orderId,
        };
        dispatch(
          orderCreationNewActions.setPreferencesFormData(
            cloneDeep(!unitInherited && !int ? defaultFormValue : formValue),
          ),
        );
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [
      clientContacts,
      categoryTitles,
      rfoToSent,
      savePacket,
      submissionEmailSetup,
      submissionPacketSetup,
      wfcToRfo,
      apiSendPacket,
      candidateTasks,
      unitInherited,
    ],
  );

  useEffect(() => {
    if (activeStep === OrderCreationStepEnum.PreviewAndSubmit && !FormDirty) {
      resetPreferenceFormForm(false);
    }
  }, [activeStep, clientContacts, categoryTitles]);

  useEffect(() => {
    if (isNewOrderCreatedFromUnit) {
      handleNext();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNewOrderCreatedFromUnit]);

  useEffect(() => {
    if (locations.current === '' && !isCancelButtonClick) {
      locations.current = location.pathname;
      if (isEdit && isDirty && !location?.pathname.includes('edit')) {
        history(`/order/${facilityId}/edit`);
        setCancelModal(true);
      } else if (!location?.pathname.includes('order/new') && !isEdit && selectedUnitId) {
        history(`/facility/${facilityId}/order/new`);
        setCancelModal(true);
      }
    }
  }, [pathname, navigationType]);

  const handleClose = () => {
    const unitDialoge = {
      dialogeOpen: false,
      dialogeItem: '',
    };
    dispatch(createOrderPreferenceActions.setUnitDialoge(unitDialoge));
    dispatch(createOrderPreferenceActions.setCustomTabValue(tabValue));
  };

  const handleNotNow = () => {
    const unitDialoge = {
      dialogeOpen: false,
      dialogeItem: '',
    };
    dispatch(createOrderPreferenceActions.setUnitDialoge(unitDialoge));
    dispatch(createOrderPreferenceActions.setCustomTabValue(tabValue));
    dispatch(createOrderPreferenceActions.setIsUnitInherited(false));
    resetPreferenceFormForm(false);
  };

  const handleAccepet = () => {
    const unitDialoge = {
      dialogeOpen: false,
      dialogeItem: '',
    };
    dispatch(createOrderPreferenceActions.setUnitDialoge(unitDialoge));
    dispatch(createOrderPreferenceActions.setCustomTabValue(tabValue));
    dispatch(createOrderPreferenceActions.setIsUnitInherited(true));
    resetPreferenceFormForm(true);
  };
  const handlePublish = () => {
    const unitDialoge = {
      dialogeOpen: false,
      dialogeItem: '',
    };
    dispatch(createOrderPreferenceActions.setUnitDialoge(unitDialoge));
    dispatch(createOrderPreferenceActions.setIsUnitInherited(false));
    dispatch(orderCreationNewActions.onSubmitOrder(history));
    dispatch(createOrderPreferenceActions.setPreferences(initialSubmissionPreferences));
  };
  const handleInheritPublish = () => {
    resetPreferenceFormForm(true);
    const unitDialoge = {
      dialogeOpen: false,
      dialogeItem: '',
    };
    dispatch(createOrderPreferenceActions.setUnitDialoge(unitDialoge));
    dispatch(createOrderPreferenceActions.setIsUnitInherited(true));
    dispatch(orderCreationNewActions.onSubmitOrder(history));
  };
  const isOrderFromUnitBackBtn = isNewOrderCreatedFromUnit && activeStep === OrderCreationStepEnum.OrderRequirements;

  return (
    <>
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(handleNext)}>
          <div className={classes.bodyContainer}>
            {activeStep === OrderCreationStepEnum.UnitSelection ? (
              <UnitSelection />
            ) : (
              <div style={{ display: 'flex' }} id="order-form">
                {!isPreviewTabSelected && (
                  <OrderNavigationMenu navRefs={navRefs} activeStep={activeStep} onItemClick={handleMenuItemClick} />
                )}
                <div className={classes.tabContainer}>
                  {/* TAB 1 Contents */}
                  {activeStep === OrderCreationStepEnum.OrderRequirements && <OrderRequirements />}

                  {/* TAB 2 Contents */}
                  {activeStep === OrderCreationStepEnum.AdditionalRequirements && <AdditionalRequirements />}

                  {/* TAB 3 Contents */}
                  {activeStep === OrderCreationStepEnum.OrderDetails && <OrderDetails />}

                  {/* TAB 4 Contents */}
                  {/* {activeStep === OrderCreationStepEnum.RateCard && <RateCard />} */}

                  {/* TAB 5 Contents */}
                  {activeStep === OrderCreationStepEnum.PreviewAndSubmit && (
                    <PreviewAndSubmit
                      currentprefData={currentFormData}
                      submissionEmailSetup={getFormattedSubmissionEmail(currentFormData)}
                      submissionPacketSetup={getFormattedSubmissionPacket(currentFormData)}
                    />
                  )}
                </div>
              </div>
            )}
            <ButtonSection>
              <Grid classes={{ root: classes.btnContainer }} spacing={4}>
                <CancelButton
                  variant="contained"
                  type="button"
                  size="large"
                  className={classes.btnStyle}
                  onClick={handleCancel}
                  disabled={isUpdating || isSubmitting || isSubmitDisabledForEdit}
                  disableElevation
                  disableRipple
                  disableFocusRipple
                >
                  {t('order.orderDetails.preferences.actions.cancel')}
                </CancelButton>

                {activeStep !== OrderCreationStepEnum.UnitSelection && !isEdit && !isOrderFromUnitBackBtn && (
                  <Button
                    variant="contained"
                    disableElevation
                    disableRipple
                    disableFocusRipple
                    color="primary"
                    size="large"
                    className={classes.btnStyle}
                    onClick={handleBack}
                    data-testid="test back button"
                  >
                    {t('search.grid.add.backButtonText')}
                  </Button>
                )}

                <Button
                  variant="contained"
                  disableElevation
                  disableRipple
                  disableFocusRipple
                  color="primary"
                  size="large"
                  className={classes.btnStyle}
                  onClick={() => handleNext()}
                  data-testid="test back button"
                  disabled={
                    isEdit
                      ? isUpdating || isSubmitDisabledForEdit
                      : activeStep === OrderCreationStepEnum.PreviewAndSubmit && !isSubmitting
                      ? false
                      : checkDisableForNext()
                  }
                >
                  {isEdit
                    ? `${t('global.button.save')}`
                    : activeStep === OrderCreationStepEnum.PreviewAndSubmit
                    ? `${t('order.newOrderCreation.tabs.publishOrder')}`
                    : `${t('global.button.next')}`}
                </Button>
              </Grid>
            </ButtonSection>
          </div>
          <GenericDialog
            open={cancelModal}
            sx={{
              '& .MuiDialogActions-root': { padding: '12px 24px 24px 24px' },
            }}
            dialogTitleProps={{
              text: t(`autoTaskManagement.dialogModal.discardChanges`),
              style: { padding: '24px 24px 12px 24px' },
            }}
            dialogContentProps={{
              style: { fontSize: '14px', padding: '0px 24px 12px 24px' },
            }}
            fullWidth
            maxWidth={'sm'}
            disableEscapeKeyDown
            dialogActions={[
              {
                onClick: handleCancelDialogClose,
                text: 'Cancel',
                variant: 'contained',
                color: 'tertiary',
              },
              {
                onClick: handleCancelConfirm,
                text: t('yes'),
                variant: 'contained',
              },
            ]}
          >
            <Typography>{t('order.newOrderCreation.editPopupMsg')}</Typography>
          </GenericDialog>
          <InheritUnitPreferenceDialog
            dialogeOpen={unitDialoge?.dialogeOpen}
            handleInheritPublish={handleInheritPublish}
            handleCancel={handleClose}
            handlePublish={handlePublish}
            handleReject={handleNotNow}
            handleAccepet={handleAccepet}
            isInheritPublish={isPrefrence}
            isInheritCancel={isPrefrence}
            isPublish={isPrefrence}
            isReject={isorderPreview}
            isAccept={isorderPreview}
            dialogeText_1={
              isPrefrence
                ? t('order.newOrderCreation.dialogePreferenceText_1')
                : t('order.newOrderCreation.dialogeText')
            }
            dialogeText_2={isPrefrence ? t('order.newOrderCreation.dialogePreferenceText_2') : ''}
            headerText={
              isPrefrence
                ? t(`autoTaskManagement.dialogModal.dialogPrefrenceModalHeader`)
                : t(`autoTaskManagement.dialogModal.dialogOrderModalHeader`)
            }
          />
          <GenericDialog
            open={removeSkillSetModal}
            sx={{
              '& .MuiDialogActions-root': { padding: '12px 24px 24px 24px' },
            }}
            dialogTitleProps={{
              text: t(`order.newOrderCreation.areYouSure`),
              style: { padding: '24px 24px 12px 24px' },
            }}
            dialogContentProps={{
              style: { fontSize: '14px', padding: '0px 24px 12px 24px' },
            }}
            fullWidth
            maxWidth={'sm'}
            disableEscapeKeyDown
            dialogActions={[
              {
                onClick: handleDialogClose,
                text: 'Cancel',
                variant: 'contained',
                color: 'tertiary',
              },
              {
                onClick: handleRemoveSkillSet,
                text: t('yes'),
                variant: 'contained',
              },
            ]}
          >
            <Typography>{t('order.newOrderCreation.removeSkillSet')}</Typography>
          </GenericDialog>
        </form>
      </FormProvider>
    </>
  );
};
